import React from 'react';
import PropTypes from 'prop-types';
import NavItem from 'react-bootstrap/lib/NavItem';
import Nav from 'react-bootstrap/lib/Nav';
import mixpanelConstants from '../mixpanelConstants';
import {trackMixpanelEvent} from '../MixpanelHelper';
import {CarouselTabs} from '../Constants';

// When used within TabbedNavigation, render will not be called
const Tab = ({
  title, titleSuffix, children
}) => (
  <div
    title={`${title} ${titleSuffix}`}
  >
    {children}
  </div>
);

Tab.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  titleSuffix: PropTypes.string,
  classes: PropTypes.string,
  tag: PropTypes.string,
  mixpanelProps: PropTypes.object // eslint-disable-line react/no-unused-prop-types
};
class TabbedNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.activeTabIndex || 0
    };
  }

  onClick = (e, index, mixpanelProps) => {
    if (mixpanelProps) {
      mixpanelProps = {...mixpanelProps, tab: index === CarouselTabs.documentTab ? mixpanelConstants.tabName.documents : mixpanelConstants.tabName.products};
      trackMixpanelEvent(mixpanelConstants.eventName.tabSwitch, mixpanelProps);
    }
    e.preventDefault()
  }

  tabToNavItem = (tab, index) => (
    tab.props.title &&
      <NavItem
        as='div'
        eventKey={index}
        title={`${tab.props.title}  ${tab.props.titleSuffix}`}
        key={index}
        data-dtm={tab.props.tag}
        data-dtm-actions={tab.props.dtmAction}
        data-dtm-attributes={tab.props.dtmAttribute}
        onClick={e => this.onClick(e, index, tab.props.mixpanelProps)}
        // eslint-disable-next-line no-script-url
        href="javascript:void(0)"
        className={tab.props.classes}
      >
        <strong>{tab.props.title} </strong>
        {tab.props.titleSuffix}
      </NavItem>
  );

  render() {
    const { children } = this.props;
    const { activeTab } = this.state;

    const navItems = children.map(this.tabToNavItem);

    const content = children[activeTab].props.children;

    return (
      <div>
        <Nav
          as='div'
          role="tablist"
          onSelect={newActiveTab => this.setState({ activeTab: newActiveTab })}
          bsStyle="pills"
          activeKey={activeTab}
        >
          {navItems}
        </Nav>
        {content}
      </div>
    );
  }
}

TabbedNavigation.propTypes = {
  children: PropTypes.arrayOf((props, index) => props[index].type === Tab).isRequired,
  activeTabIndex: PropTypes.number
};

export { Tab, TabbedNavigation };
